import formatGradeRangeString from "@/chiron/PlatformAlignment/utils/formatGradeRangeString";
import { SubjectProductLabel } from "@/components/ContentPromotions/types";
import { ContentPromotionVenue } from "@/components/ContentPromotions/types/ContentPromotionVenue.enum";
import { ContentPromotionForm } from "@/types/models/ContentPromotionForm.interface";

export const getGradeRangeTextForSelectedForm = (
  selectedContentPromotionForm: ContentPromotionForm | undefined,
) => {
  if (!selectedContentPromotionForm) return "";

  const currentGradeRange = {
    min_grade: selectedContentPromotionForm.grade_minimum ?? 0,
    max_grade: selectedContentPromotionForm.grade_maximum ?? 12,
  };

  return formatGradeRangeString(currentGradeRange, true);
};

export const getSubjectProductLabelForSelectedForm = (
  selectedContentPromotionForm: ContentPromotionForm | undefined,
) => {
  if (!selectedContentPromotionForm) return "";

  const subjectProductSlug = selectedContentPromotionForm.product_slug;
  return SubjectProductLabel[subjectProductSlug];
};

interface ParamsToGeneratePageTitle {
  selectedForm: ContentPromotionForm | undefined;
  venue: ContentPromotionVenue;
}

export const generatePageTitle = ({
  selectedForm,
  venue,
}: ParamsToGeneratePageTitle) => {
  if (!selectedForm) return;

  return `Promoted content at your ${venue} for ${getSubjectProductLabelForSelectedForm(selectedForm)} ${getGradeRangeTextForSelectedForm(selectedForm)}`;
};
